import request from '@/utils/request'

export function getPackageDetailListApi(query) {
  return request({
    url: '/config-service/v1/package/package-detail/list-by-package',
    method: 'get',
    params: query
  })
}

export function getPackageDetailApi({ id }) {
  return request({
    url: `/config-service/v1/package/package-detail/${id}`,
    method: 'get'
  })
}

export function addPackageDetailApi(payload) {
  return request({
    url: '/config-service/v1/package/package-detail',
    method: 'post',
    data: payload
  })
}

export function updatePackageDetailApi(payload) {
  return request({
    url: '/config-service/v1/package/package-detail',
    method: 'put',
    data: payload
  })
}

export function deletePackageDetailApi(payload) {
  return request({
    url: '/config-service/v1/package/package-detail',
    method: 'delete',
    data: payload
  })
}
